import { type FC } from 'react';

import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { ContentSection } from '../../components/ContentSection';
import { ListingLayoutContainer } from '../ListingLayoutContainer';
import { MapLayoutContainer } from '../MapLayoutContainer';
import { ViewModeSwitchersContainer } from '../ViewModeSwitchersContainer';

export const ContentContainer: FC = () => {
  const viewMode = useListingLayoutViewModeSelector();

  return (
    <ContentSection
      listing={<ListingLayoutContainer />}
      map={<MapLayoutContainer />}
      viewMode={viewMode}
      viewModeSwitchers={<ViewModeSwitchersContainer />}
    />
  );
};
